import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import { routes } from "../../../utlis/admin/routes.utlis";
import ApiService from "../../../core/services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import {
  status,
  totalPageCalculator,
  LIMIT
} from "../../../utlis/common.utlis";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";


const Page = () => {
  const navigate = useNavigate();
  const [users, setUser] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [addEmp, setAddEmp] = useState({ status: false });
  const [deleteUser, setDeleteUser] = useState({ status: false, id: null });
  const [stat, setStat] = useState({ status: false, value: null, name: null });
  const [editEmp, setEditEmp] = useState({ status: false, data: null });

  const initialValues = {
    name: "",
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required!"),
    password: Yup.string()
      .required("Password is required!")
      .min(6, "Password must be 6 characters long."),
    email: Yup.string()
      .email("Email is invalid!")
      .required("Email is required!"),
  });

  const getUserList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setUser(response.data.data.subadmin);
      setTotal(response.data.data.total);
    } else setUser([]);
    setLoading(false);
  };


  const addEmployee = async (formValue) => {
    setLoading(true);
    const formData = {
      fullname: formValue.name,
      email: formValue.email,
      password: formValue.password,
      user_type: 5, // 5 for employee
    }
    const response = await ApiService.postAPIWithAccessToken(
      api.employeeCreate,
      formData
    );
    setAddEmp({ status: false });
    if (response.data.status) {
      toast.success(response.data.message);
      getUserList(
        api.employeeList + `?page=${pageNum}&limit=${LIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const changeStatus = async (status, userid) => {
    setLoading(true);
    const form = JSON.stringify({
      status: parseInt(status),
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.userChangeStatus + `${userid}`,
      form
    );
    setStat({ status: false, value: null });
    if (response.data.status && response.data.statusCode === 200) {
      toast.success("Employee status updated successfully");
      getUserList(
        api.employeeList + `?page=${pageNum}&limit=${LIMIT}`
      );
      setLoading(false);
    } else toast.error(response.data.message);
    setLoading(false);
  };

  const deleteEmployee = async (id) => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.employeeDelete + `${id}`
    );
    setDeleteUser({
      status: false,
      id: null,
    });

    if (response.data.status) {
      toast.success(response.data.message);
      getUserList(
        api.employeeList + `?page=${pageNum}&limit=${LIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getUserList(
      api.employeeList +
      `?page=${pageNum}&limit=${LIMIT}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="carenetwork-section">


          <div className="care-title-header">
            <h2 className="heading-title">Employee Management</h2>
            <div className="cc-search-filter wd50">
              <div className="row g-2">
                <div className="col-md-5"></div>
                <div className="col-md-7">
                  <div className="form-group">
                    <button type="button" className="btn-gr w-100" onClick={() => setAddEmp({ status: true })} >
                      + Add Employee
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="carenetwork-content cc-table-card">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th> Name </th>
                    <th> Email ID </th>
                    <th> Registered On </th>
                    <th> Status </th>
                    <th> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {users.length !== 0 ? (
                    users.map((ele, indx) => {
                      return (
                        <tr key={indx}>
                          <td className="text-capitalize">
                            {ele.fullname ?? "NA"}
                          </td>
                          <td className="text-lowercase">
                            {" "}
                            {ele.email ?? "NA"}{" "}
                          </td>
                          <td>
                            {moment(ele.created_date).format("MM-DD-yyyy")}
                          </td>
                          <td>
                            <select className={`form-control status-dropdown ${ele.status === '1' ? "active" : "inactive"
                              }`}
                              name="status"
                              onChange={(e) =>
                                setStat({
                                  status: true,
                                  value: e.target.value,
                                  name: status(e.target.value),
                                  userid: ele.userid,
                                })
                              }
                              value={ele.status}
                            >
                              <option value="1" > Active </option>
                              <option value="2" > Inactive </option>
                            </select>
                          </td>
                          <td>
                            <button
                              className="badge badge-gradient-success"
                              type="button"
                              onClick={() => setEditEmp({ status: true, data: ele })}
                              title="Edit Employee"
                            >
                              <i className="fa fa-pencil"></i>
                            </button>

                            &nbsp;
                            <button
                              style={{ background: "#ba4831", color: "#fff" }}
                              type="button"
                              className="badge"
                              onClick={() => {
                                setDeleteUser({
                                  status: true,
                                  id: ele.userid,
                                });
                              }}
                              title="Delete Employee"
                            >
                              <i className="mdi mdi-delete menu-icon"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="6">
                        <div>
                          <p>No Employee found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="d-flex align-items-center justify-content-center mt-3">
                {users.length !== 0 ? (
                  <div className="care-table-pagination">
                    <ul className="care-pagination">
                      {pageNum !== 1 && (
                        <li
                          className="disabled"
                          id="example_previous"
                          onClick={() => setPageNum(pageNum - 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="0"
                            tabIndex="0"
                            className="page-link"
                          >
                            Previous
                          </Link>
                        </li>
                      )}

                      {totalPageCalculator(total, LIMIT).length === 1
                        ? null
                        : totalPageCalculator(total, LIMIT).map(
                          (pageNo, indx) => {
                            return (
                              <li
                                className={pageNo === pageNum ? "active" : ""}
                                key={indx}
                                onClick={() => setPageNum(pageNo)}
                              >
                                <Link to="" className="page-link">
                                  {pageNo}
                                </Link>
                              </li>
                            );
                          }
                        )}

                      {pageNum !== Math.ceil(total / LIMIT) && (
                        <li
                          className="next"
                          id="example_next"
                          onClick={() => setPageNum(pageNum + 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="7"
                            tabIndex="0"
                            className="page-link"
                          >
                            Next
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Employee Modal */}

      <Modal
        show={addEmp.status}
        onHide={() => {
          setAddEmp({
            status: false,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Add New Employee</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={addEmployee}
              >
                <Form className="findcare-form">
                  <div className="form-group">
                    <h4>Name</h4>
                    <Field
                      type="text"
                      className="form-control todo-list-input"
                      name="name"
                      placeholder="Enter Full Name"
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group">
                    <h4>Email *</h4>
                    <Field
                      type="email"
                      className="form-control todo-list-input"
                      name="email"
                      placeholder="Enter Email Address"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group">
                    <h4>Password *</h4>
                    <Field
                      type="password"
                      className="form-control todo-list-input"
                      name="password"
                      placeholder="Enter Password"
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>

                  <div className="form-group text-end">
                    <button
                      type="button"
                      onClick={() => {
                        setAddEmp({
                          status: false,
                        });
                      }}
                      className="btn-re me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-gr"
                      data-bs-dismiss="modal"
                    >
                      Add Employee
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteUser.status}
        onHide={() => {
          setDeleteUser({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} alt="" />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Employee</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete this
                  Employee ?
                </p>
              </div>
              <div className="form-group text-center mb-0">
                <button
                  type="button"
                  onClick={() =>
                    setDeleteUser({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteEmployee(deleteUser.id)}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={stat.status}
        onHide={() => {
          setStat({
            status: false,
            value: null,
            name: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0 mt-2">Change Status</h5>
                <p className="text-center">
                  Are you sure you want to{" "}
                  <span className="text-lowercase">{stat.name}</span> this user
                  ?
                </p>
              </div>
              <div className="form-group text-center">
                <button
                  type="button"
                  onClick={() =>
                    setStat({
                      status: false,
                      value: null,
                      name: null,
                    })
                  }
                  className="btn-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-gr me-2"
                  data-bs-dismiss="modal"
                  onClick={() => changeStatus(stat.value, stat.userid)}
                >
                  Yes! {stat.name}
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editEmp.status}
        onHide={() => setEditEmp({ status: false, data: null })}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Employee</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                enableReinitialize
                initialValues={{
                  name: editEmp.data?.fullname || "",
                  email: editEmp.data?.email || "",
                  password: "",
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Name is required!"),
                  email: Yup.string().email("Email is invalid!").required("Email is required!"),
                  // Password is NOT required for edit
                  password: Yup.string().min(6, "Password must be 6 characters long."),
                })}
                onSubmit={async (formValue) => {
                  setLoading(true);
                  let formData = {
                    fullname: formValue.name,
                    email: formValue.email,
                    userid: editEmp.data.userid,
                  };
                  // Only include password if not blank
                  if (formValue.password && formValue.password.trim() !== "") {
                    formData.password = formValue.password;
                  }
                  const response = await ApiService.putAPIWithAccessToken(
                    api.employeeUpdate + `${editEmp.data.userid}`,
                    formData
                  );
                  setEditEmp({ status: false, data: null });
                  if (response.data.status) {
                    toast.success(response.data.message);
                    getUserList(api.employeeList + `?page=${pageNum}&limit=${LIMIT}`);
                  } else {
                    toast.error(response.data.message);
                  }
                  setLoading(false);
                }}
              >
                <Form className="findcare-form">
                  <div className="form-group">
                    <h4>Name</h4>
                    <Field
                      type="text"
                      className="form-control todo-list-input"
                      name="name"
                      placeholder="Enter Full Name"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group">
                    <h4>Email *</h4>
                    <Field
                      type="email"
                      className="form-control todo-list-input"
                      name="email"
                      placeholder="Enter Email Address"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group">
                    <h4>Password *</h4>
                    <Field
                      type="password"
                      className="form-control todo-list-input"
                      name="password"
                      placeholder="Enter Password (leave blank to keep unchanged)"
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group text-end">
                    <button
                      type="button"
                      onClick={() => setEditEmp({ status: false, data: null })}
                      className="btn-re me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn-gr" data-bs-dismiss="modal">
                      Update Employee
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

    </>
  );
};

export default Page;
